import { FunctionalComponent, h } from '@stencil/core';
import state from '@ugc-store';
import { stringFormat, toLocalSeparator } from '@ugc-utils/utils';

const ViewDesktop: FunctionalComponent = () => {
  const {
    qnaStaticLanguage: { IDS_UGC_QNA_SEE_ALL_QNA = '', IDS_NO_RESULTS_QUESTIONS = '' },
    isFirstLoad,
    isQnaLoaded,
    qids,
    questionBreakUpById,
    qnaListStaticTotalCount = 0,
    productInfo: { partNumber = '' },
  } = state;
  const questionListLength = qids.length;
  // render empty
  const renderEmpty = isQnaLoaded && !isFirstLoad && (
    <div class="mt-48" data-testid="no-results">
      <ugc-title
        size={18}
        height={36}
        style={{
          display: 'block',
          margin: '24px auto 16px',
          textAlign: 'left',
        }}
        text={IDS_NO_RESULTS_QUESTIONS}
      />
    </div>
  );

  // render list
  const renderList = (
    <div class="mt-16">
      {qids.map(qid => {
        return <ugc-question-and-answer key={qid} questionListItem={questionBreakUpById[qid]} />;
      })}
      <div class="flex-row-center-center">
        <ugc-read-more
          href={(window.location.pathname || '').replace('pr', 'qna')}
          partNumber={partNumber}
          data-testid="pdp-qna-see-all-qna"
        >
          <span class="bold">{stringFormat(IDS_UGC_QNA_SEE_ALL_QNA, toLocalSeparator(qnaListStaticTotalCount))}</span>
        </ugc-read-more>
      </div>
    </div>
  );

  return questionListLength > 0 ? renderList : renderEmpty;
};

export default ViewDesktop;
